import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import React from "react";
import { ReactComponent as IconEdit } from "../../../../shared/assets/Icons/Icon_Edit.svg";
import { ReactComponent as IconDelete } from "../../../../shared/assets/Icons/Icon_Delete.svg";

export interface LastMile {
  id:number;
	idCharge: string;
	vendorId: number;
  name: string;
	state: string;
	city: string;
	countryId: string;
	zip_start: string;
	zip_end: string;
}

export const columns: GenericTableColumn<LastMile>[] = [
	{
		header: "ID Charge",
		accessor: "idCharge",
	},

	{
		header: "Name",
		accessor: "name",
	},
	{
		header: "State",
		accessor: "state",
	},
	{
		header: "City",
		accessor: "city",
	},
	{
		header: "Country ID",
		accessor: "countryId",
	},
	{
		header: "Zip Start",
		accessor: "zip_start",
	},
	{
		header: "Zip End",
		accessor: "zip_end",
	},
	{
		header: "Actions",
		// We only need a valid string for 'accessor'; real rendering is in renderCell
		accessor: "state",
		renderCell: (row) => (
			<div className="flex items-center gap-2">
				{/* View Button */}
				<button
					className="
            px-3 py-1
            border border-semantic-border-secondary
            rounded
            text-semantic-text-secondary
            hover:bg-semantic-state-active
          "
					onClick={() => {
						console.log("View data center:", row);
					}}
				>
					View
				</button>

				{/* Edit Button */}
				<button
					className="
            flex items-center justify-center
            border border-semantic-border-secondary
            rounded
            text-semantic-text-secondary
            hover:bg-semantic-state-active
            w-10 h-10
          "
					onClick={() => {
						console.log("Edit data center:", row);
					}}
				>
					<IconEdit className="w-5 h-5" />
				</button>

				{/* Delete Button */}
				<button
					className="
            p-2
            border border-semantic-border-secondary
            rounded
            bg-red-50
            text-red-600
            hover:bg-red-100
          "
					onClick={() => {
						console.log("Delete data center:", row);
					}}
				>
					<IconDelete className="w-5 h-5" />
				</button>
			</div>
		),
	},
];

